import React from 'react';
import { useLocation, Link, useParams } from 'react-router-dom';

import { Breadcrumbs, Link as MuiLink, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { homeNavigationSection, navigationSections } from "../config/navigationConfig";
import { getBreadcrumbTrail } from '../utils';

interface BreadcrumbProps {
  permitNo?: string | undefined;
  siteId?: string | undefined;
  batchId?: string | undefined;
}

const Breadcrumb: React.FC<BreadcrumbProps> = () => {

  const location = useLocation();
  const params = useParams();

  const breadcrumbItems = getBreadcrumbTrail(location.pathname, [...homeNavigationSection, ...navigationSections], params as Record<string, string>);

  const buildHref = (href: string, label: string) => {
    return href?.replace(/:([a-zA-Z]+)/g, (_, key) => {
      return params[key] || label;
    });
  };

  return (
    <Breadcrumbs
      separator={<ChevronRightIcon fontSize="small" sx={{ fontSize: 20 }} />}
      aria-label="breadcrumb"
      sx={{
        overflowX: 'auto',
        '& ol': {
          display: 'flex',
          flexWrap: 'nowrap',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          overflowX: 'auto',
        },
        scrollbarColor: 'transparent transparent',
      }}
    >
      {breadcrumbItems.map((item: any, index: any) => {
        const IconComponent = item.icon?.type;
        const isLastItem = index === breadcrumbItems.length - 1;
        const finalHref = buildHref(item.href, item.label);

        const labelFormatted = item?.label?.replace(/\b\w/g, (char: string) => char.toUpperCase());

        if (isLastItem) {
          return (
            <Typography
              key={item.href}
              color="text.secondary"
              sx={{ display: 'flex', alignItems: 'center' }}
              variant="body2"
            >
              {IconComponent && (
                <IconComponent
                  fontSize="small"
                  sx={{ mr: 1.5, fontSize: 18, color: 'text.secondary' }}
                />
              )}
              {labelFormatted}
            </Typography>
          );
        }

        return (
          <MuiLink
            key={item.href}
            component={Link}
            to={finalHref}
            underline="hover"
            color="text.primary"
            sx={{ display: 'flex', alignItems: 'center' }}
            variant="body2"
          >
            {IconComponent && (
              <IconComponent
                fontSize="small"
                sx={{ mr: 1.5, fontSize: 18, color: 'text.secondary' }}
              />
            )}
            {labelFormatted}
          </MuiLink>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
